import CreateAccount from './CreateAccount.component';
export default CreateAccount;